<template>
  <div class="position-relative h-100">

    <div v-if="showSingleLoginRegistration && !isLoggedIn" class="h-100">
      <a class="nav-link" :class="linkClass" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" :aria-label="$translate('Ceres::Template.login')" @click="createRegisterLoginModal(); unmarkInputFields();">
        <span v-if="loginLogo.length > 0" class="logo-navbar" :style="{ 'background-image' : `url('${loginLogo}')` }"></span>
        <i v-else class="fa fa-user mr-1" :class="logoClass"  aria-hidden="true"/>
      </a>
    </div>

    <div v-if="isLoggedIn" class="dropdown d-flex align-items-center h-100">
      <a href="#" class="dropdown-toggle nav-link" :class="linkClass" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
        <i class="fa fa-user mr-1 d-sm-none" aria-hidden="true"></i>
        <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
      </a>
      <div class="dropdown-menu small m-0 p-0 mw-100">
        <div class="list-group" aria-labelledby="accountMenuList">
          <a :href="$ceres.urls.myAccount" class="list-group-item small"><i class="fa fa-user"></i> {{ $translate("Ceres::Template.loginMyAccount") }}</a>
          <a href="#" class="list-group-item small" v-logout><i class="fa fa-sign-out"></i> {{ $translate("Ceres::Template.loginLogout") }}</a>
        </div>
      </div>
    </div>
    <div v-if="!isLoggedIn & !showSingleLoginRegistration" class="h-100">
      <a v-if="showLogin && loginMode === 'modal'" class="nav-link" :class="linkClass" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" :aria-label="$translate('Ceres::Template.login')" @click="createLoginModal(); unmarkInputFields();">
        <i class="fa fa-user mr-1" :class="logoClass" aria-hidden="true"/>
        <span v-if="showLoginText" class="d-none d-sm-inline">{{ $translate("Ceres::Template.login") }}</span>
      </a>
      <a v-if="showLogin && loginMode != 'modal'" class="nav-link " :class="linkClass" :href="routeLogin">
        <i class="fa fa-user mr-1" :class="logoClass" aria-hidden="true"></i>
        <span v-if="showLoginText" class="d-none d-sm-inline">{{ $translate("Ceres::Template.login") }}</span>
      </a>
      <template v-if="showRegistration">
        <span class="pipe" v-if="!showLogin"></span>
        <a v-if="registrationMode === 'modal'" class="nav-link" :class="linkClass" :href="isRegister ? 'javascript:void(0)' : '#registration'" :data-toggle="isRegister ? false : 'modal'" aria-label="$translate('Ceres::Template.loginRegister')" @click="createRegisterModal(); unmarkInputFields();">
          <i class="fa fa-user-plus mr-1"  :class="logoClass" aria-hidden="true"></i>
          <span v-if="showRegistrationText" class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginRegister") }}</span>
        </a>
        <a v-else class="nav-link" :class="linkClass" :href="routeRegistration">
          <i class="fa fa-user-plus mr-1" :class="logoClass" aria-hidden="true"></i>
          <span v-if="showRegistrationText" class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginRegister") }}</span>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import ValidationService from '../../../services/ValidationService'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    logoClass: {type: String, default: "", required: false},
    loginLogo: {type: String, default: "", required: false},
    showSingleLoginRegistration: { type: Boolean, default: false },
    showRegistration: {
      type: Boolean,
      default: true
    },
    showLogin: {
      type: Boolean,
      default: true
    },
    showRegistrationText: {
      type: Boolean,
      default: true
    },
    showLoginText: {
      type: Boolean,
      default: true
    },
    registrationMode: {
      type: String,
      default: 'modal'
    },
    loginMode: {
      type: String,
      default: 'modal'
    },
    routeRegistration: {
      type: String
    },
    routeLogin: {
      type: String
    },
    linkClass: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters([
      'username',
      'isLoggedIn'
    ])
  },

  data () {
    return {
      isLogin: App.templateType === 'login',
      isRegister: App.templateType === 'register'
    }
  },

  methods: {
    unmarkInputFields () {
      ValidationService.unmarkAllFields($('#login'))
      ValidationService.unmarkAllFields($('#registration'))
    },

    createLoginModal () {
      this.loadComponent('login-modal')
    },

    createRegisterModal () {
      this.loadComponent('register-modal')
    },

    createRegisterLoginModal () {
      this.loadComponent('login-modal')
      this.loadComponent('register-modal')
    },

    ...mapActions([
      'loadComponent'
    ])
  }
}
</script>
